import {
  CButton,
  FormGroup,
  disableButton,
  handleNavigationStatus,
} from '@maw/utility';
import {
  ActionFunctionArgs,
  Form,
  LoaderFunction,
  useActionData,
  useNavigation,
} from 'react-router-dom';
import Card from '../../../Card';
import { queryClient, upsertResource } from '../../../../util/request';
import Container from '../../../Container';
import { useRedirect } from '../../../../hooks/redirect';
import Alert from '../../../Alert';
import { disableWhenLoading } from '../../../../util/helper';

export default function NewAsset() {
  const actionData: any = useActionData();
  const navigation = useNavigation();

  useRedirect(actionData, 'assets', true);

  return (
    <Container>
      <Alert data={actionData} />
      <Container.Heading>New Asset(image)</Container.Heading>
      <Container.SubHeading>
        Authorized user can write file.
      </Container.SubHeading>
      <Card>
        <Card.Header>New asset</Card.Header>
        <Form method='post' encType='multipart/form-data' noValidate>
          <FormGroup>
            <FormGroup.Input
              labelclassname='bg-gray-100'
              type='file'
              id='assets[]'
              title='Image (MaxHeight: 500, MaxWidth: 800)'
              accept='.jpeg, .png, .jpg, .svg'
              multiple
              data={actionData}
              disabled={disableWhenLoading(navigation)}
            />
            <CButton
              rounded
              variant='primary'
              type='submit'
              disabled={disableButton(navigation)}
              className='mt-6'
            >
              {handleNavigationStatus(navigation, 'Submit')}
            </CButton>
          </FormGroup>
        </Form>
      </Card>
    </Container>
  );
}

export async function action({
  request,
}: ActionFunctionArgs): Promise<LoaderFunction> {
  await queryClient.invalidateQueries({ queryKey: ['assets'] });
  return await upsertResource({
    request,
    resource: 'assets',
    isFormData: true,
    action: 'create',
  });
}
